<template>
  <div>
    <div class="all conent">
      <div class="tabs">
        <div class="tab-item tab-item-active">备件领用</div>
      </div>
      <div>
        <el-form :inline="true"
                 :model="dataForm"
                 @keyup.enter.native="getDataList(1)"
                 @submit.native.prevent
                 label-width="110px">
          <div class="search-row">
            <div class="search-conent">
              <el-form-item label="领用单号：">
                <el-input v-model="dataForm.receiveCode"
                          placeholder="领用单号"
                          clearable></el-input>
              </el-form-item>
            </div>
            <div class="search-conent">
              <el-form-item label="状态：">
                <el-select v-model="dataForm.status"
                           clearable
                           placeholder="当前状态">
                  <el-option v-for="item in statusList"
                             :key="item.code"
                             :label="item.value"
                             :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="search-but">
              <button class="info-but"
                      @click="getDataList(1)">查询</button>
            </div>
          </div>
          <div class="search-row">
            <div class="search-conent">
              <el-form-item label="申请时间：">
                <el-date-picker v-model="dataForm.dateValue"
                                type="daterange"
                                align="left"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format='yyyy-MM-dd'
                                style="width:230px;"
                                :disabled="dataForm.dateValue3 ? true : false"></el-date-picker>
              </el-form-item>
            </div>
            <div class="search-conent">
              <el-form-item>
                <!-- <el-checkbox-group v-model="dataForm.dateValue2" :max="1" :disabled="Boolean(dataForm.dateValue)">
          <el-checkbox v-for="data in dateOptions" :label="data.code" :key="data.code">{{data.value}}</el-checkbox>
      </el-checkbox-group> -->
                <el-radio-group v-model="dataForm.dateValue3"
                                :disabled="Boolean(dataForm.dateValue)">
                  <el-radio v-for="data in dateOptions"
                            :label="data.value"
                            :key="data.code"
                            @click.native.stop="(e) => clickItem(e,data.value)">{{data.value}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="search-but">
              <button class="info-but"
                      @click="reset()">重置</button>
            </div>
          </div>
          <div class="search-row">
            <div class="search-conent">
              <el-form-item label="用户物品编码：">
                <el-input v-model="dataForm.custGoodsCode"
                          placeholder="用户物品编码"
                          clearable></el-input>
              </el-form-item>
            </div>
            <div class="search-conent">
              <el-form-item label="物品型号：">
                <el-input v-model="dataForm.model"
                          placeholder="物品型号"
                          clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="search-row">
            <div class="search-conent">
              <el-form-item label="物品名称：">
                <el-input v-model="dataForm.goodsName"
                          placeholder="物品名称"
                          clearable></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="opt-row">
        <div class="opt-left">
          <button class="info-but info-but-new"
                  @click="handleSaveReceive"><i class="el-icon-plus"></i>新增</button>
        </div>
      </div>
      <el-table :data="dataList"
                border
                @selection-change="selectionChangeHandle">
        <el-table-column type="index"
                         width="50"
                         label="序号"></el-table-column>
        <el-table-column prop="orderCode"
                         header-align="center"
                         align="center"
                         label="领用单号"
                         show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="orderStatus"
                         header-align="center"
                         align="center"
                         label="状态"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.orderStatus === '10'">提交领用</div>
            <div v-if="scope.row.orderStatus === '30'">仓储受理</div>
            <div v-if="scope.row.orderStatus === '59' || scope.row.orderStatus === '41'">已完成</div>
            <div v-if="scope.row.orderStatus === '99'">已取消</div>
            <div v-if="scope.row.orderStatus === '49'">已评价</div>
            <div v-if="scope.row.orderStatus === '31'">物流配送</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime"
                         header-align="center"
                         align="center"
                         label="申请时间"
                         show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right"
                         header-align="center"
                         align="center"
                         width="190"
                         label="操作">
          <template slot-scope="scope">
            <!-- 不能修改详情页 -->
            <el-button type="text"
                       size="small"
                       @click="openDetailHandle(scope.row.orderId)"
                       v-if="scope.row.orderStatus !== '10'">查看详情</el-button>
            <!-- 可以修改详情页 -->
            <el-button type="text"
                       size="small"
                       @click="openDetailUpdate(scope.row.orderId)"
                       v-if="scope.row.orderStatus === '10'">查看详情</el-button>
            <el-button type="text"
                       size="small"
                       v-if="scope.row.orderStatus === '31' || scope.row.orderStatus === '59' || scope.row.orderStatus === '49'"
                       @click="deliveryHandle(scope.row)">发货单详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination  @size-change="sizeChangeHandle"
                      @current-change="currentChangeHandle"
                      :current-page="currentPage"
                      :page-sizes="[10, 20, 50, 100]"
                      :page-size="pageSize"
                      :total="totalPage"
                      layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
      <!-- <div class="doclist-pagination"
           v-if="dataList.length">
        <div class="doclist-lastpage"
             @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':''"
              v-for="item in pageList"
              :key="item"
              @click="changePageTo(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage"
             @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text"
                 v-model.number="jumpTargetPage">页</div>
        <div class="doclist-jump"
             @click="jumpFarPage">确定</div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeStatus: '1',
      selectList: [],
      dataForm: {
        receiveCode: '',
        status: '',
        customerName: '',
        custGoodsCode: '', // 用户物品编码
        model: '', // 物品型号
        goodsName: '', // 物品名称
        dateValue: null,
        dateValue2: [],
        dateValue3: ''
      },
      statusList: [
        // {code:'0', value:'提交领用'},
        // {code:'1', value:'仓储受理'},
        // {code:'5', value:'物流配送'},
        // {code:'3', value:'已取消'}
        // {code:'4', value:'评价'},
        // {code:'2', value:'完成'},
        { code: '10', value: '提交领用' },
        { code: '30', value: '仓储受理' },
        { code: '31', value: '物流配送' },
        { code: '99', value: '已取消' },
        { code: '49', value: '已评价' },
        { code: '59', value: '已完成' }
      ],
      dateOptions: [
        { code: '0', value: '1个月' },
        { code: '1', value: '3个月' },
        { code: '2', value: '半年' },
        { code: '3', value: '一年' }
      ],
      dataList: [],
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      pageSize: 10,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1 // 跳转页
      // pickerOptions: {
      //   disabledDate(time) {
      //     return time.getTime() >= (Date.now())
      //   }
      // }
    }
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    clickItem (e, value) {
      e.preventDefault()
      value === this.dataForm.dateValue3
        ? (this.dataForm.dateValue3 = '')
        : (this.dataForm.dateValue3 = value)
    },
    // 多选
    selectionChangeHandle (list) {
      this.selectList = list
    },
    routerHandle (routerName) {
      this.$router.push(routerName)
    },
    handleSaveReceive () {
      let params = {
        companyId: localStorage.getItem('defaultCompanyId') !== '' ? localStorage.getItem('defaultCompanyId') : null
      }
      this.$http.post(`/front/order/lclb/accountbill/checkPaid`, params)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$router.push({ name: 'spareGetAdd' })
          }
        })
    },
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      this.getDataList(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.currentPage = val
      this.getDataList()
    },
    getDataList (currentPage = this.currentPage) {
      // var timeTag = this.dataForm.dateValue3
      // if (this.dataForm.dateValue2.length === 0){
      //   timeTag = ''
      // } else {
      //   timeTag = this.dataForm.dateValue2[0]
      // }
      var timeTag
      if (this.dataForm.dateValue3 === '1个月') {
        timeTag = '0'
      } else if (this.dataForm.dateValue3 === '3个月') {
        timeTag = '1'
      } else if (this.dataForm.dateValue3 === '半年') {
        timeTag = '2'
      } else if (this.dataForm.dateValue3 === '一年') {
        timeTag = '3'
      } else {
        timeTag = ''
      }
      let params = {
        page: currentPage,
        limit: this.pageSize,
        orderStatus: this.dataForm.status,
        orderCode: this.dataForm.receiveCode,
        startDate: this.dataForm.dateValue ? this.dataForm.dateValue[0] : '',
        endDate: this.dataForm.dateValue ? this.dataForm.dateValue[1] : '',
        timeTag: this.dataForm.dateValue ? '' : timeTag,
        oldGoodsCode: this.dataForm.custGoodsCode,
        oldModel: this.dataForm.model,
        oldGoodsName: this.dataForm.goodsName,
        companyId: localStorage.getItem('defaultCompanyId') !== '' ? localStorage.getItem('defaultCompanyId') : null
      }
      this.$http.post(`/front/order/lclb/receive/listByOrdinary`, params)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataList = res.data.data
            this.totalPage = Math.ceil((Number(res.data.count) || 0) / 10)
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.setPageTo(currentPage)
        })
        .catch(() => {
          this.dataList = []
        })
    },
    setPageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    // 清空form
    reset () {
      this.dataForm = {
        receiveCode: '',
        status: '',
        customerName: '',
        dateValue: null,
        dateValue2: [],
        dateValue3: ''
      }
      this.getDataList(1)
    },
    // 跳转详情
    openDetailHandle (id) {
      this.$router.push({ name: 'spareGetDetail', query: { id: id } })
    },
    deliveryHandle (row) {
      this.$router.push({
        name: 'shipmentDetail',
        query: {
          orderId: row.orderId,
          orderCode: row.orderCode,
          orderStatus: this.$getDictLabel('ORDER_STATUS', row.orderStatus),
          userName: row.applyUserName,
          companyName: row.companyName
        }
      })
    },
    openDetailUpdate (id) {
      this.$router.push({ name: 'spareGetDetailUpdate', query: { id: id } })
    }
  }
}
</script>
<style scoped>
.conent {
  width: 970px;
  padding: 20px 20px;
}
.search-row {
  display: flex;
}
.search-conent {
  min-width: 350px;
  margin-right: 20px;
}
.search-but {
  width: 100%;
  min-width: 200px;
  text-align: right;
}
.opt-row {
  width: 100%;
  display: flex;
  text-align: right;
  margin-bottom: 20px;
}
.opt-right {
  width: 300px;
}
.opt-left {
  width: 100%;
  text-align: left;
}
.info-but {
  background: #ffffff;
  width: 96px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #1d65a8;
  letter-spacing: 0;
  border: none;
  cursor: pointer;
  user-select: none;
  border: 1px solid #1d65a8;
  margin-right: 10px;
}
.info-but:hover {
  background: #1d65a8;
  color: #ffffff;
}
.info-but-new {
  background: #1d65a8;
  color: #ffffff;
}
.but-file {
  background-color: #ffffff;
  border: none;
}
.demand-desc {
  width: 100%;
  cursor: pointer;
}
.tip {
  max-width: 500px;
  word-wrap: break-word;
  word-break: break-all;
}
.red {
  color: red;
}
.detail-icon {
  cursor: pointer;
}
.detail-icon:hover {
  color: #1d65a8;
}
.tooltip-content {
  width: 60px;
  text-align: center;
  border-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.short-content {
  max-height: 69px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tabs{
  height: 48px;
  margin: 0 69px;
}
.tab-item{
  display: inline-block;
  /* padding: 12px 16px; */
  text-align: center;
  background: #FFFFFF;
  /* box-shadow: inset 0 -1px 0 0 #DDDDDD; */
  /* width: 88px; */
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  letter-spacing: 0;
  margin-right: 24px;
  cursor: pointer;
}
.tab-item-active{
  color: #1D65A8;
  border-bottom: 2px solid #1D65A8;
}
.tab-item-content{
  padding-top: 10px;
}
</style>
